import type { SelectorOption } from '@/app/components/form/Selector/types';

export const QUICK_ADD_CLIENT_SOURCE_VALUES = [1, 2, 3, 4, 5, 6] as const;

export type QuickAddClientSourceValue = (typeof QUICK_ADD_CLIENT_SOURCE_VALUES)[number];

export const DEFAULT_QUICK_ADD_CLIENT_SOURCE: QuickAddClientSourceValue = QUICK_ADD_CLIENT_SOURCE_VALUES[0];

export const QUICK_ADD_CLIENT_SOURCE_OPTIONS: SelectorOption<number>[] = [
  {
    value: QUICK_ADD_CLIENT_SOURCE_VALUES[0],
    label: 'Smartflyer.com',
  },
  {
    value: QUICK_ADD_CLIENT_SOURCE_VALUES[1],
    label: 'Virtuoso.com',
  },
  { value: QUICK_ADD_CLIENT_SOURCE_VALUES[2], label: 'Phone' },
  { value: QUICK_ADD_CLIENT_SOURCE_VALUES[3], label: 'Referral' },
  { value: QUICK_ADD_CLIENT_SOURCE_VALUES[4], label: 'Instagram' },
  { value: QUICK_ADD_CLIENT_SOURCE_VALUES[5], label: 'Facebook' },
];
